.scan-to-batch-modal {
  width: 600px;
  min-width: 500px;
  height: 300px;
}

.modal-body {
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;

  .modal-sub-header {
    font-size: 2em;
    margin-bottom: 15px;
  }

  .instructions {
    margin-top: auto;
    margin-bottom: 20px;
  }
}
